import { render, staticRenderFns } from "./play.vue?vue&type=template&id=1506402c&scoped=true"
import script from "./play.vue?vue&type=script&lang=js"
export * from "./play.vue?vue&type=script&lang=js"
import style0 from "./play.vue?vue&type=style&index=0&id=1506402c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1506402c",
  null
  
)

export default component.exports